import {RouteRecordRaw} from "vue-router";
import WelcomePage from "@/modules/base/pages/WelcomePage.vue";

export const routes: RouteRecordRaw[] = [
  {
    path: '/introduction/welcome',
    name: 'introduction.welcome',
    component: WelcomePage,
  },
];